import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./slices/adminSlice";
import collectionsReducer from "./slices/collectionsSlice";
import brandsShowcaseReducer from "./slices/brandsShowcaseSlice";
import uiContentReducer from "./slices/uiContentSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    collections: collectionsReducer,
    brandsShowcase: brandsShowcaseReducer,
    uiContent: uiContentReducer,
  },
});

export default store;
